import { render, staticRenderFns } from "./TrelloColumn.vue?vue&type=template&id=6990235e&scoped=true&"
import script from "./TrelloColumn.vue?vue&type=script&lang=js&"
export * from "./TrelloColumn.vue?vue&type=script&lang=js&"
import style0 from "./TrelloColumn.vue?vue&type=style&index=0&id=6990235e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990235e",
  null
  
)

export default component.exports